<template id="branch">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12" v-if="ebranch.bchid == null">
        <div class="formHeadings"> <span><img src="@/images/creatbranch.png" alt="#"></span>{{res.createb}}</div>
      </div>
      <div class="col-md-12 col-sm-12" v-else>
        <div class="formHeadings"> <span><img src="@/images/creatbranch.png" alt="#"></span>{{res.update}}</div>
      </div>
      <div class="col-md-10 col-sm-10 col-md-offset-1 col-sm-offset-1 col-xs-12 col-xs-offset-0">
        <div :class="'col-md-12 col-sm-12 '+(mode=='edit'?'':'flex_inputblock')">
          <inputbox v-model="ebranch.name" :isfloat="false" :res="res" :name="'name'" :title="res.name"></inputbox>
          <div class="inputBlock small" v-if="mode!='edit'" style="z-index:1">
            <label for="">{{res.islogin}}</label>
            <a class="toggler active" v-on:click="toggleLogin()">
              <i :class="'fa fa-toggle-on '+(isLogin?'on':'off')"></i>
              <i :class="'fa fa-toggle-off '+(isLogin?'off':'on')"></i>
            </a>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="isLogin">
          <inputbox v-model="ebranch.email" :isfloat="false" :res="res" :name="'email'" :title="res.email"></inputbox>
        </div>
        <!--div class="col-md-12 col-sm-12" id="a_email">
          <div class="inputBlock">
            <label for="">Login email*</label>
            <input type="text" class="form-control inputText" placeholder="John Doe" v-model="ebranch.email">
          </div>
        </div-->
        <div class="col-md-6 col-sm-6" v-if="mode!='edit' && isLogin" id="a_pwd">
          <inputbox v-model="ebranch.password" :boxtype="'password'" :isfloat="false" :res="res" :name="'password'" :title="res.password"></inputbox>
          <!--div class="inputBlock">
            <label for="exampleInputPassword1">Password</label>
            <input type="password" class="form-control inputText" id="exampleInputPassword1" placeholder="" v-model="ebranch.password">
          </div-->
        </div>
        <div class="col-md-6 col-sm-6" v-if="mode!='edit' && isLogin">
          <inputbox v-model="ebranch.cpassword" :boxtype="'password'" :isfloat="false" :res="res" :name="'cpassword'" :title="res.cpassword"></inputbox>
          <!--div class="inputBlock">
            <label for="exampleInputPassword1">Confirm Password</label>
            <input type="password" id="password" name="password" class="form-control inputText" placeholder="" v-model="ebranch.cpassword">
          </div-->
        </div>
        <div class="col-md-6 col-sm-6" id="a_poc">
          <inputbox v-model="ebranch.poc" :isfloat="false" :res="res" :name="'poc'" :title="res.poc"></inputbox>
          <!--div class="inputBlock">
            <label for="">Contact person*</label>
            <input type="text" class="form-control inputText" placeholder="John Doe" v-model="ebranch.poc">
          </div-->
        </div>
        <div class="col-md-6 col-sm-6" id="a_tel">
          <inputbox v-model="ebranch.tel" :isfloat="false" :res="res" :name="'tel'" :title="res.tel"></inputbox>
          <!--inputbox :custom="'+852'" v-model="ebranch.tel" :isfloat="false" :res="res" :name="'tel'" :title="res.tel"></inputbox-->
          <!--div class="inputBlock">
            <label for="">Contact phone*</label>
            <div class="customBlk">
              <div class="left">+852</div>
              <input type="text" class="form-control inputText" placeholder="" v-model="ebranch.tel">
            </div>
          </div-->
        </div>
        <div class="col-md-12 col-sm-12">
          <inputbox v-model="ebranch.address1" :isfloat="true" :res="res" :name="'address1'" :title="res.address1"></inputbox>
          <inputbox v-model="ebranch.address2" :isfloat="true" :res="res" :name="'address2'" :title="res.address2"></inputbox>
          <inputbox v-model="ebranch.address3" :isfloat="true" :res="res" :name="'address3'" :title="res.address3"></inputbox>
          <inputbox v-model="ebranch.address4" :isfloat="true" :res="res" :name="'address4'" :title="res.address4"></inputbox>
          <div v-if="1==2" id="a_deliveryremark" class="inputBlock"><label class="floatLeft" for="" v-html="res.deliveryremark"></label>
            <textarea name="deliveryremark" v-model="ebranch.deliveryremark" class="form-control inputText floatRight inputRightAligned" style="border-radius:8px !important"></textarea>
            <div class="clearFix"></div>
          </div>
          <!--div class="inputBlock" id="a_addr1">
            <label for="" class="floatLeft">Address line 1*</label>
            <input type="text" class="form-control inputText floatRight inputRightAligned" placeholder="Unit D, 3/F, V Ga Building" v-model="ebranch.address1">
            <div class="clearFix"></div>
          </div-->
          <!--div class="inputBlock" id="a_addr2">
            <label for="" class="floatLeft">Address line 2</label>
            <input type="text" class="form-control inputText floatRight inputRightAligned" placeholder="532 Castle Peak Rd" v-model="ebranch.address2">
            <div class="clearFix"></div>
          </div-->
          <!--div class="inputBlock" id="a_addr3">
            <label for="" class="floatLeft">Address line 3</label>
            <input type="text" class="form-control inputText floatRight inputRightAligned" placeholder="Cheung Sha Wan, Kowloon" v-model="ebranch.address3">
            <div class="clearFix"></div>
          </div>
          <div class="inputBlock" id="a_addr4">
            <label for="" class="floatLeft">Address line 4</label>
            <input type="text" class="form-control inputText floatRight inputRightAligned" placeholder="" v-model="ebranch.address4">
            <div class="clearFix"></div>
          </div-->
        </div>
      </div>
      <div class=" col-md-12 col-sm-12 col-xs-12" v-if="mode=='edit'" id="a_pwd">
        <div class="formHeadings"> <span><img src="@/images/passthumb.png" alt=""></span>{{res.chgpwd}}</div>
      </div>
      <div class="col-md-offset-1 col-md-6 col-sm-6" v-if="mode=='edit'">
        <inputbox v-model="ebranch.ppassword" :boxtype="'password'" :isfloat="false" :res="res" :name="'ppassword'" :title="res.ppassword"></inputbox>
        <inputbox v-model="ebranch.password" :boxtype="'password'" :isfloat="false" :res="res" :name="'password'" :title="res.password"></inputbox>
        <inputbox v-model="ebranch.cpassword" :boxtype="'password'" :isfloat="false" :res="res" :name="'cpassword'" :title="res.cpassword"></inputbox>
      </div>
      <div class="col-md-12 col-sm-12 text-center btnwrapper">
        <input v-if="ebranch.bchid == null" type="button" class="form-control submitButton" :value="res.createb" v-on:click="insBranch()">
        <input v-else type="button" class="form-control submitButton" :value="res.update" v-on:click="updBranch()">
        <input v-if="mode!='edit'" type="button" class="form-control submitButton" :value="res.cancel" v-on:click="cancel()">
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>

import utils from './Utils.vue'
import inputbox from './InputBox.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'branch',
  props:['info', 'mode', 'res'],
  data () {
    return {
      nologin:false,
      ebranch:null,
      locale:null,
      token:null,
      isLogin:true,
      submitted:false
    }
  },
  components: {
    inputbox
  },
  created: function() {
    var self = this;
    this.ebranch = this.info;
    this.locale = utils.getLocale();
  },
  methods: {
    toggleLogin() {
      this.isLogin = !this.isLogin;
    },
    cancel() {
      this.$root.$emit('cancelBranch');
    },
    updBranch(response) {
      if (this.submitted) return;
      this.submitted = true;
      var self = this;
      var isok = true;
      var goto = null;
      if (response != null) {
        try {
          this.ebranch['g-recaptcha-response'] = response;
        } catch (e) {}
      }

      if (!this.chk('name', /^.{1,}$/, this.res.name_err)) {
        isok = false;
        if (!goto) goto = 'name';
      } else if (!this.chk('name', /^.{1,255}$/, this.res.name_toolong)) {
        isok = false;
        if (!goto) goto = 'name';
      }

      if (this.isLogin) {
        if (!this.chk('email', /^.{1,}$/, this.res.email_err)) {
          isok = false;
          if (!goto) goto = 'email';
        } else if (!this.chk('email', /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i, this.res.contact_email_invalid)) {
          isok = false;
          if (!goto) goto = 'email';
        }

        //if (!this.chk('password', /^.{1,}$/, this.res.password_err)) {
        //  if (!goto) goto = 'password';
        //  isok = false;
        //}

        this.$root.$emit('cpassword');
        this.$root.$emit('ppassword');
        if (this.nologin && (this.ebranch.password == null || this.ebranch.password == '')) {
          if (!this.chk('password', /^.{1,255}$/)) {
            isok = false;
            if (!goto) goto = 'password';
          }
        }
        if (this.ebranch.password != null) {
          this.ebranch.password = this.ebranch.password.trim();
        }
        if (this.ebranch.password != null && this.ebranch.password.trim() != '') {
          if (this.ebranch.password != this.ebranch.cpassword) {
            if (!goto) goto = 'pwd';
            isok = false;
            this.$root.$emit('cpassword', {"error":this.res.cpassword_err});
          }
          if (this.ebranch.ppassword == '') {
            if (!goto) goto = 'pwd';
            isok = false;
            this.$root.$emit('ppassword', {"error":this.res.ppassword_err});
          }
        }
      } else {
        this.ebranch.email = '';
      }

      if (!this.chk('poc', /^.{1,}$/, this.res.poc_err)) {
        isok = false;
        if (!goto) goto = 'poc';
      } else if (!this.chk('poc', /^.{1,255}$/, this.res.poc_toolong)) {
        isok = false;
        if (!goto) goto = 'poc';
      }

      if (!this.chk('tel', /^.{1,}$/, this.res.tel_err)) {
        isok = false;
        if (!goto) goto = 'tel';
      } else if (!this.chk('tel', /^[0-9]{8,50}$/, this.res.tel_invalid)) {
        isok = false;
        if (!goto) goto = 'tel';
      }

      if (!this.chk('address1', /^.{1,}$/, this.res.addr1_err)) {
        if (!goto) goto = 'address1';
        isok = false;
      } else if (!this.chk('address1', /^.{1,255}$/, this.res.addr1_toolong)) {
        isok = false;
        if (!goto) goto = 'address1';
      }

      if (!this.chk('address2', /^.{0,255}$/, this.res.addr2_toolong)) {
        isok = false;
        if (!goto) goto = 'address2';
      }
      if (!this.chk('address3', /^.{0,255}$/, this.res.addr3_toolong)) {
        isok = false;
        if (!goto) goto = 'address3';
      }
      if (!this.chk('address4', /^.{0,255}$/, this.res.addr4_toolong)) {
        isok = false;
        if (!goto) goto = 'address4';
      }

      if (isok) {
        var mode = 'ins';
        if (this.ebranch.bchid) {
          mode = 'upd';
        }
        if (this.nologin && this.isLogin) {
          this.ebranch.islogin = 'true';
        }
        utils.saveData({
            url: utils.getServerPath()+'/account/updBranch.is',
            mode: 'update',
            repos: 'db',
            value: utils.saveJSONToForm(this.ebranch),
            name: 'account.branch'
          }, function(success, data) {
            if (success) {
              if (data.success != 1) {
                if (data.form) {
                  Object.keys(data.form).forEach(function(key) {
                    if (data.form[key] != 0) {
                      this.$root.$emit(key, {"error":" Invalid value"});
                      $("#a_"+key)[0].scrollIntoView();
                    }
                  });
                }
                if (data.success == -2 || data.success == -4) {
                  $("#a_email")[0].scrollIntoView();
                  self.$root.$emit('email', {"error":self.res.email_used});
                } else if (data.success == -3) {
                  $("#a_email")[0].scrollIntoView();
                  self.$root.$emit('email', {"error":self.res.email_used});
                } else if (data.success == -5) {
                  $("#a_pwd")[0].scrollIntoView();
                  self.$root.$emit('ppassword', {"error":self.res.wrong_password});
                }
                self.$forceUpdate();
              } else {
                self.info = data.saved;
                data.mode = mode;
                self.$root.$emit('savedBranch', data);
              }
            }
            self.submitted = false;
            //grecaptcha.reset();
        });
      } else {
        //grecaptcha.reset();
        self.submitted = false;
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        self.$forceUpdate();
      }
    },
    insBranch(response) {
      this.updBranch(response);
    },
    chk: function(name, regex, errmsg) {
      if (regex) {
        var chkval = (this.ebranch[name])?this.ebranch[name]:'';
        if (!regex.test(chkval)) {
          if (!errmsg) errmsg = " "+this.res.isreq;
          this.$root.$emit(name, {"error":errmsg});
          return false;
        } else {
          this.$root.$emit(name);
          return true;
        }
      }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    }
  },
  mounted: function() {
    this.ebranch = this.info;
    if (this.ebranch.bchid == null) {
      this.mode = 'ins';
    } else if (this.mode == null) {
      this.mode = 'upd';
      if (this.ebranch.email == '') {
        this.isLogin = false;
        this.nologin = true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Branch.vue